import { collection, doc, onSnapshot, query } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from './firebaseConfig';
import './game.css';

function QuestionDisplay({ joinCard }) {
    const [question, setQuestion] = useState();
    const [currentQuestion, setCurrentQuestion] = useState(false);

    useEffect(() => {
        const questionsCollection = collection(db, 'question');
        const questionsQuery = query(questionsCollection);

        const unsubscribe = onSnapshot(questionsQuery, (snapshot) => {
            const updatedQuestions = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }));


            const filtered = updatedQuestions.filter((x) => x.id === currentQuestion)
            setQuestion(filtered.length > 0 ? filtered[0] : null)
        });

        return () => unsubscribe();
    }, [currentQuestion]);

    useEffect(() => {

        const unsub = onSnapshot(doc(db, "currentQuestion", "UEsaFssIIvcTBHM9hejH"), (doc) => {

            const data = doc.data();

            setCurrentQuestion(data?.id || "")

        });

        return () => unsub();

    }, []);


    function getQuestionText(itemText) {
        try {
            return (JSON.parse(itemText)).text;
        } catch {
            return "";
        }
    }


    function getAnswers(itemText) {
        try {
            return (JSON.parse(itemText)).answers || [];
        } catch {
            return [];
        }
    }


    return (
        <div className="game-stage question-stage">
            {question && <>
                <div className="question-panel">
                <div className="question-topbar">
                    <div className="question-display-header">
                        <p className="game-kicker">50+ Desi Couples Trivia Night</p>
                        <h1>Good Times, Great Company</h1>
                    </div>
                    {joinCard}
                </div>
                <div className="question-card">
                  <h1>{getQuestionText(question.text)}</h1>
                </div>
                <div className="answer-grid">

                {
                    getAnswers(question.text).map((answer, answerIndex) => {
                        return <button
                            className="answer-tile is-disabled"
                            key={answer.id || answerIndex}
                            type="button"
                        >
                            <span className="answer-marker">{answerIndex + 1}</span>
                            {answer.text}
                        </button>
                    })
                }
                </div>
                </div>
            </>}
        </div>
    )
}

export default QuestionDisplay
